import React from 'react';
import {Row, Col} from 'react-bootstrap';

export default function VarianceTable({
  groupId, 
  budgetScopes, 
  timeEntriesPerBand,
  fteDivisor
}) {
  const renderVariance = () => {
    let varianceRows = [];
    let bandTimeEntries = {}
    let totalManhoursVariance = 0;
    let totalMandaysVariance = 0;
    let totalPercentage = 0;
    let totalFTE = 0;

    timeEntriesPerBand.forEach(item => {
      bandTimeEntries = item
    })

    let fte = 0;
    //get total manhours variance
    budgetScopes.length &&  budgetScopes.filter(data => {
      if (!['F', 'G'].includes(data.band_group)) {
        return data;
      }
      return false;
    }).forEach(budgetScope => {
      let budgetMandays = budgetScope.mandays;
      if (Object.keys(bandTimeEntries).length) {
        let actualMandays = ((+bandTimeEntries['band' + budgetScope.band_group]) / 8).toFixed(2);
        const mandaysVariance = budgetMandays - actualMandays;

        let budgetManhours = budgetScope.manhours;
        let actualManhours = ((+bandTimeEntries['band' + budgetScope.band_group])).toFixed(2);
    
        const manhoursVariance = budgetManhours - actualManhours;

        totalManhoursVariance += manhoursVariance; 
        totalMandaysVariance += mandaysVariance;
        totalFTE += fte;
      }
    })

    varianceRows = budgetScopes.length ? budgetScopes.filter(data => {
      if (!['F', 'G'].includes(data.band_group)) {
        return data;
      }
      return false;
    }).map(budgetScope => {
      let percentage = 0;
      let mandaysVariance = 0;
      let manhoursVariance = 0;

      if (Object.keys(bandTimeEntries).length) {
        let budgetMandays = budgetScope.mandays;
        let actualMandays = ((+bandTimeEntries['band' + budgetScope.band_group]) / 8).toFixed(2);
  
        mandaysVariance = budgetMandays - actualMandays;

        fte = mandaysVariance / fteDivisor;
  
        let budgetManhours = budgetScope.manhours;
        let actualManhours = ((+bandTimeEntries['band' + budgetScope.band_group])).toFixed(2);
        
        manhoursVariance = budgetManhours - actualManhours;

        percentage = (manhoursVariance / totalManhoursVariance) * 100;
        totalPercentage +=  percentage;
        totalFTE += fte;
      }
    
      return (
        <Row>
          <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"variance-mandays-" + groupId}>
              {mandaysVariance.toFixed(2)}
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"variance-manhours-" + groupId}>
              {manhoursVariance.toFixed(2)}
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"variance-percentage-" + groupId}>
              {percentage.toFixed(2)}%
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"variance-fte-" + groupId}>
              {fte.toFixed(2)}
            </span>
          </Col>
        </Row>
      )
    }) : [] 

    varianceRows.length && varianceRows.push(
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"variance-mandays-" + groupId}>
            {totalMandaysVariance.toFixed(2)}
          </span>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"variance-manhours-" + groupId}>
            {totalManhoursVariance.toFixed(2)}
          </span>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"variance-percentage-" + groupId}>
            {totalPercentage.toFixed(2)}%
          </span>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"variance-fte-" + groupId}>
            {totalFTE.toFixed(2)}
          </span>
        </Col>
      </Row>
    )

    return varianceRows;
  }

  return (
    <>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Mandays</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Manhours</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Percentage</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">FTE</Col>
      </Row>
      { renderVariance() }
    </>
  )
}
